(function(root){
'use strict';
function createModel(catalog){
 const F=catalog.families,P=catalog.products;
 const bundles={};
 for(const f of F){
  for(const h of Object.keys(P)){
   if(h.startsWith(f.chain+'-and-')&&h.endsWith('-set'))bundles[h]=[f.chain,f.bracelet];
   if(f.pendant&&h===f.pendant+'-and-'+f.bracelet+'-set')bundles[h]=[f.pendant,f.bracelet];
   if(f.pendant&&h===f.pendant+'-and-'+f.chain+'-stack')bundles[h]=[f.pendant,f.chain];
  }
 }
 function logical(cart){const map=new Map();for(const item of cart.items||[]){for(const h of bundles[item.handle]||[item.handle])if(!map.has(h))map.set(h,item);}return map;}
 function offers(cart){
  const present=logical(cart);const out=[];
  const priority=F.flatMap(f=>f.pendant?[f.pendant,f.chain,f.bracelet]:[f.chain,f.bracelet]);
  const lead=priority.find(h=>present.has(h));if(!lead)return out;
  const focus=F.find(f=>[f.chain,f.pendant,f.bracelet].includes(lead));
  const source=present.get(lead);const finish=String(source.variant_title||'').toLowerCase();
  const add=(handle,kind,reference)=>{if(handle&&!present.has(handle)&&!out.some(x=>x.handle===handle))out.push({handle,kind,reference,finish,family:focus.id});};
  const n=present.has(focus.chain)||!!focus.pendant&&present.has(focus.pendant),b=present.has(focus.bracelet);
  if(n&&!b)add(focus.bracelet,'set-bracelet',focus.chain);
  if(b&&!n){add(focus.pendant||focus.chain,'set-necklace',focus.bracelet);if(focus.pendant)add(focus.chain,'set-necklace',focus.bracelet);}
  if(focus.pendant&&n){if(!present.has(focus.chain))add(focus.chain,'stack-necklace',focus.pendant);if(!present.has(focus.pendant))add(focus.pendant,'stack-necklace',focus.chain);}
  for(const f of F.filter(f=>f.id!==focus.id&&!!f.pendant===!!focus.pendant)){if(f.pendant)add(f.pendant,'regular',null);add(f.chain,'regular',null);}
  return out.slice(0,6);
 }
 return {offers,logical,bundles};
}
if(typeof module==='object'&&module.exports)module.exports={createModel};else root.AciellCtlModel={createModel};
})(typeof window==='object'?window:globalThis);
